import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { ErrorHandler, NgModule, inject, provideAppInitializer } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MAT_SNACK_BAR_DEFAULT_OPTIONS } from '@angular/material/snack-bar';
import { BrowserModule } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { MsalInterceptor, MsalModule, MsalRedirectComponent, MsalService } from '@azure/msal-angular';
import { AppSharedModule } from '@modules/shared/app-shared.module';
import { LicensesComponent } from '@modules/shared/dialogs/licenses/licenses.component';
import * as Sentry from '@sentry/angular';
import { MarkdownModule } from 'ngx-markdown';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { RetryInterceptor } from './interceptors/retry-interceptor';
import { SideNavModule } from './modules/side-nav/side-nav.module';
import { ForbiddenComponent } from './pages/forbidden/forbidden.component';
import { TranslocoRootModule } from './transloco-root.module';
import {
  DateAdapter,
  MAT_DATE_FORMATS,
  MAT_DATE_LOCALE,
  MAT_NATIVE_DATE_FORMATS,
  provideNativeDateAdapter,
} from '@angular/material/core';
import { CalendarInputDateAdapter } from '@modules/form/components/calendar-input/calendar-input.date-adapter';
import { TranslateService } from '@services/translate.service';

@NgModule({
  declarations: [AppComponent, ForbiddenComponent, LicensesComponent],
  exports: [AppSharedModule],
  bootstrap: [AppComponent, MsalRedirectComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    MsalModule,
    SideNavModule,
    TranslocoRootModule,
    AppSharedModule,
    MarkdownModule.forRoot(),
  ],
  providers: [
    {
      provide: MAT_SNACK_BAR_DEFAULT_OPTIONS,
      useValue: {
        duration: 5000,
        verticalPosition: 'top',
        horizontalPosition: 'center',
        panelClass: 'snackbar',
      },
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: MsalInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: RetryInterceptor,
      multi: true,
    },
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler({
        showDialog: false,
      }),
    },
    {
      provide: Sentry.TraceService,
      deps: [Router],
    },
    provideAppInitializer(() => {
      const initializerFn = (() => () => {
        inject(Sentry.TraceService);
      })();
      return initializerFn();
    }),
    MsalService,
    provideHttpClient(withInterceptorsFromDi()),

    // Material Datepicker
    provideNativeDateAdapter(),
    { provide: DateAdapter, useClass: CalendarInputDateAdapter },
    { provide: MAT_DATE_FORMATS, useValue: MAT_NATIVE_DATE_FORMATS },
    {
      provide: MAT_DATE_LOCALE,
      useFactory: (translateService: TranslateService) => translateService.getActiveLang(),
      deps: [TranslateService],
    },
  ],
})
export class AppModule {}
